module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-6369788e27746ef54a8e806e60436309.png";